import { toast } from 'react-toastify';
import { Api } from '../lib/api/api';
import {addSystemLogs} from '../../src/actions/SystemLogs';
import { EPIK_V2_URL } from '../lib/constants';
import { getUserPermissionGroup } from './PermissionGroups';
import { getPermissionForComponent } from '../utils/permissionsUtils';

const getPostLoginRedirectUrl = user => {
  if (
    user?.epikV2Access ||
    user?.permissionsGroup === 'Engineering' ||
    getPermissionForComponent('epikV2Access', user?.permissionsGroup)
  ) {
    return EPIK_V2_URL;
  }
  return '/';
};

export const getUserData = token => async dispatch => {
  if (!token) {
    return {};
  }
  const api = new Api(token);
  dispatch({
    type: 'FETCH_USER',
  });
  try {
    const user = await api.users.myInfo();
    await localStorage.setItem('resetPassword', user?.resetPassword || false);
    dispatch({
      type: 'FETCH_USER_SUCCESS',
      user,
    });
    return user;
  } catch (error) {
    const message = error.response.data;
    dispatch({
      type: 'FETCH_USER_FAILURE',
      error: message,
    });
    toast.error('Error getting user information, please login again', {
      toastId: 'FETCH_USER_FAILURE',
    });
    return { error };
  }
};
export const getUserDataByToken = token => async dispatch => {
  if (!token) {
    return {};
  }
  const api = new Api(token);
  try {
    const user = await api.users.myInfo();
    await localStorage.setItem('resetPassword', user?.resetPassword || false);
    dispatch({
      type: 'FETCH_USER_SUCCESS',
      user,
    });
    return user;
  } catch (error) {
    const message = error.response.data;
    dispatch({
      type: 'FETCH_USER_FAILURE',
      error: message,
    });
    toast.error('Error getting user information, please login again', {
      toastId: 'FETCH_USER_FAILURE',
    });
    return { error };
  }
};

export const logout = (token, intervalId) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'USER_LOGOUT',
  });
  try {
    await api.users.logout();
    dispatch({
      type: 'USER_LOGOUT_SUCCESS',
    });
    toast.success('You were logged out.', { toastId: 'USER_LOGOUT_SUCCESS' });
    clearInterval(intervalId)
  } catch (error) {
    const message = error.response.data.error;
    dispatch({
      type: 'USER_LOGOUT_FAILURE',
      error,
    });
  }
};

export const enableDeleteMode = () => async dispatch => {
  dispatch({
    type: 'ENABLE_DELETE_MODE',
  });
};

export const disableDeleteMode = () => async dispatch => {
  dispatch({
    type: 'DISABLE_DELETE_MODE',
  });
};

export const toggleCollapse = data => async dispatch => {
  dispatch({
    type: 'TOGGLE_COLLAPSE',
    data,
  });
};

export const sendOtp = id => async dispatch => {
  const api = new Api();
  dispatch({
    type: 'SEND_OTP',
  });
  try {
    await api.users.sendOtp(id);
    dispatch({
      type: 'SEND_OTP_SUCCESS',
    });
    toast.success('OTP sent successfully.', { toastId: 'SEND_OTP_SUCCESS' });
    return { success: true };
  } catch (error) {
    const message = error.response.data.error;
    toast.error(message || 'Error sending OTP. Please try again', {
      toastId: 'SEND_OTP_FAILURE',
    });
    return { success: false };
  }
};

export const sendEmailOtp = () => async dispatch => {
  const api = new Api();
  dispatch({
    type: 'SEND_EMAIL_OTP',
  });
  try {
    await api.users.sendEmailOtp();
    dispatch({
      type: 'SEND_EMAIL_OTP_SUCCESS',
    });
    toast.success('OTP sent successfully.', { toastId: 'SEND_EMAIL_OTP_SUCCESS' });
    return { success: true };
  } catch (error) {
    const message = error?.response?.data?.error;
    toast.error(message || 'Error sending OTP. Please try again', {
      toastId: 'SEND_EMAIL_OTP_FAILURE',
    });
    return { success: false };
  }
};

export const getUserLoginHistory = (token, userID, paginateOptions) => async dispatch => {
  const api = new Api(token);
  try {
    const data = await api.users.getUserLoginHistory(userID, paginateOptions);
    dispatch({
      type: 'USER_LOGIN_HISTORY_FETCH_SUCCESS',
    });
    return data;
  } catch (error) {
    console.log(error.message)
    return {
      failure: true
    };
  }
};


export const registerRequest = (body,csrfToken) => async () => {
  const api = new Api();
  try {
    const result = await api.users.registerRequest(body,csrfToken);
    console.log("API RESULT", result);
    return result;
  } catch (error) {
    const message = error.response.data;
    toast.error(message || 'Error sending OTP. Please try again', {
      toastId: 'REGISTER_REQUEST_FAILURE',
    });
  }
};

export const login = (username, password, comingFrom, authMode = 'sms') => async dispatch => {
  const api = new Api();
  dispatch({
    type: 'USER_LOGIN',
    username,
    password,
  });
  try {
    const userData =
      comingFrom === '2fa'
        ? await api.users.authenticate(username, password, authMode)
        : await api.users.login(username, password);

    if (userData.user.twoFactor) {
      dispatch({
        type: 'USER_LOGIN_SUCCESS',
        user: {
          email: userData.user.email,
          id: userData.user._id,
          phoneNumber: userData.user.phoneNumber,
          default2fa: userData?.user?.default2fa
        },
        token: null,
      });
      window.location.href = '/2fa';
      toast.success('Check app for 2FA code.', {
        toastId: 'USER_LOGIN_SUCCESS',
      });
    } else {
      const body = {
        actionType: 'system',
        description: 'User Login'
      };
      await dispatch(addSystemLogs(userData.user, body));
      dispatch({
        type: 'USER_LOGIN_SUCCESS',
        user: null,
        token: userData.user,
      });
      const user = await dispatch(getUserData(userData.user));
      await dispatch(getUserPermissionGroup(userData.user));
      toast.success('Successfully logged in.', { toastId: 'USER_LOGIN_SUCCESS' });
      window.location.href = getPostLoginRedirectUrl(user);
    }
  } catch (error) {
    const message = error?.response?.data?.error;
    dispatch({
      type: 'USER_LOGIN_ERROR',
      error: message,
    });
    if(message === "User Disable"){
      dispatch({ type: 'USER_DISABLED', error: message });
    }else{
    toast.info(message || 'Error logging in. Please try again', { toastId: 'USER_LOGIN_ERROR' });
    }
  }
};
export const captcahRequest = () => async () => {
  const api = new Api();
  try {
    const result = await api.users.getCaptchaRequest();
    return result;
  } catch (error) {
    const message = error.response.data.error;
    toast.error(message || 'Error getting captcha. Please try again', {
      toastId: 'CAPTCHA_REQUEST_FAILURE',
    });
  }
};